var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuburguer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 328.716,
    height: 245.093,
    viewBox: "0 0 328.716 245.093",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    "data-name": "Path 170",
    d: "M0,95.625V124.95H328.716V95.625ZM0,232.5H328.716v-29.18H0ZM0,340.718H328.716v-29.71H0Z",
    transform: "translate(0 -95.625)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuburguer);
export default __webpack_public_path__ + "static/media/menuburguer.6acbca8d424b93082cfda710e383fc0a.svg";
export { ForwardRef as ReactComponent };